

export class TestPrinter {
    hideClass = "hide"

    constructor() {
        this.addListeners();
    }

    addListeners(){
        const $this = this;
        $("#ab-print").on("click", function(){
            $this.toggleAll();
            setTimeout(function(){
                window.print();
                $this.toggleAll();
            }, 1500);
        });
    }


    toggleAll(){
        this.toggleBreadcrumb();
        this.toggleHeader();
        this.toggleLeftSidebar();
        this.togglePageWrapper();
        this.togglePageContent();
        this.toggleTextareas();
        this.toggleInputs();
    }

    toggleFooter(){
        $("footer").toggleClass(this.hideClass)
    }

    toggleInputs(){
        $(".form-check-input").css("border", "1px solid black");
        $("table").css("width", "70%");
    }

    toggleTextareas(){
        $("textarea").css("resize", "none");
    }

    toggleBreadcrumb(){
        $(".page-breadcrumb").toggleClass(this.hideClass);
    }

    toggleHeader(){
        $("header").toggleClass(this.hideClass);
    }

    toggleLeftSidebar(){
        $(".left-sidebar").toggleClass(this.hideClass);
    }

    togglePageWrapper(){
        const wrapper = $(".page-wrapper");
        const m = (wrapper.css("margin-left") == "65px") ? 0 : "65px";
        wrapper.css("margin-left", m);
    }

    togglePageContent(){
        const content = $(".page-content");
        const p = (content.css("padding") == "30px") ? 0 : "30px";
        content.css("padding", p);
    }
}